import { PagedApiResponse } from '../../utils/types/shared/paged-api-response.type';
import { Injectable } from "@angular/core";

@Injectable()
export class SharedMapper {

    mapPagedApiResponse<T>(data: any, mapper: (data: any, objectType?: any) => Array<T>, objectType?: any): PagedApiResponse<T> {
        const response = new PagedApiResponse<T>();
        response.totalNumberOfRecords = data.totalNumberOfRecords;
        response.list = mapper(data.list, objectType);

        return response;
    }
}
